/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { makeStyles } from '@material-ui/core/styles';

const Styles = makeStyles((theme) => {
    const { palette, breakpoints: { maxWidth } } = theme;
    return {
        productItemContainerWrapper: {
            '& a': {
                textDecoration: 'underline',
            },
            '& .productItemContainer': {
                cursor: 'pointer',
                wordBreak: 'break-all',
                fontFamily: 'Hind, sans-serif',
                position: 'relative',
                padding: '0 15px',
                marginBottom: '1.5rem',
                '& .imageContainer': {
                    background: 'linear-gradient(-90deg, #e3e3e3 35%, #fcfcfc 50%, #e3e3e3 65%)',
                    backgroundSize: '300% 300%',
                    backgroundColor: '#e3e3e3',
                    width: '100%',
                    minHeight: '300px',
                    position: 'relative',
                    [theme.breakpoints.down('994')]: {
                        minHeight: '155px',
                    },
                },
                '& .productImage': {
                    position: 'relative',
                    '& img': {
                        width: '100%',
                    },
                },
                '& img': {
                    width: '100%',
                },
                '& .title': {
                    wordBreak: 'inherit',
                    width: '60%',
                    [theme.breakpoints.down('994')]: {
                        fontSize: '0.875rem',
                        lineHeight: '0.875rem',
                    },
                    '&.withComparePrice': {
                        width: '45%',
                        wordBreak: 'inherit',
                    },
                    float: 'left',
                    paddingRight: '5px',
                    color: '#212121',
                    fontWeight: '400',
                    letterSpacing: '0',
                    '&.plant-occasion-title': {
                        color: 'black',
                        fontSize: '16px !important',
                        lineHeight: '24px !important',
                        letterSpacing: '0.8px',
                        opacity: '1',
                        width: 'unset !important',
                    },
                },
                '& .only-title': {
                    textAlign: 'center',
                },
                '& .title-row': {
                    marginTop: '1rem',
                },
                '& .no-float': {
                    float: 'none',
                },
                '& .price': {
                    fontWeight: '700',
                    textAlign: 'right',
                    width: '40%',
                    [theme.breakpoints.between('769', '1025')]: {
                        fontSize: '0.875rem',
                        letterSpacing: '-0.6px',
                    },
                    '& .withComparePrice': {
                        width: '55%',
                        wordBreak: 'keep-all',
                    },
                    float: 'left',
                    '& .line': {
                        textDecoration: 'line-through',
                        marginBottom: '0',
                        [theme.breakpoints.between('769', '1025')]: {
                            fontSize: '0.875rem',
                        },
                    },
                    '&.plant-occasion-price': {
                        width: '100% !important',
                        textAlign: 'left',
                        '& .line, .plant-occasion-price-color': {
                            color: 'black',
                        },
                    },
                },
                '& .wrapUpTitle': {
                    wordBreak: 'inherit',
                    width: '100%',
                    [theme.breakpoints.down('994')]: {
                        fontSize: '0.875rem',
                        lineHeight: '0.875rem',
                    },
                    float: 'left',
                    paddingRight: '5px',
                    color: '#212324',
                    fontWeight: '400',
                    letterSpacing: 0,
                },
                '& .wrapUpPrice': {
                    fontWeight: '700',
                    width: '100%',
                    textDecoration: 'none',
                    [theme.breakpoints.between('768', '1025')]: {
                        fontSize: '0.875rem',
                        letterSpacing: '-0.6px',
                    },
                    float: 'left',
                    '& .line': {
                        textDecoration: 'line-through',
                    },
                },
                [theme.breakpoints.down('768')]: {
                    fontSize: '1.125rem',
                    '&.productItemContainer': {
                        fontSize: '1rem',
                        '& .price .wishListContainer': {
                            top: '10px',
                            right: '10px',
                        },
                        '& .title': {
                            minHeight: '35px',
                            width: '100%',
                            wordBreak: 'unset',
                            float: 'left',
                            padding: '0',
                            display: 'block',
                            '&.withComparePrice': {
                                width: '100%',
                                wordBreak: 'unset',
                            },
                        },
                        '& .price': {
                            width: '100%',
                            textAlign: 'left',
                            '&.withComparePrice': {
                                with: '100%',
                                wordBreak: 'unset',
                            },
                            '& span': {
                                paddingLeft: '3px',
                                '&:first-child': {
                                    paddingLeft: '0px',
                                },
                                '&:empty': {
                                    '& ~span': {
                                        paddingLeft: '0px !important',
                                    },
                                },
                            },
                        },
                        '&.slider': {
                            padding: '0',
                        },
                        '&:nth-child(odd)': {
                            paddingRight: '8px',
                        },
                        '&:nth-child(even)': {
                            paddingLeft: '8px',
                            '& .wishListContainer': {
                                right: '21px !important',
                            },
                        },
                    },
                    '& .wishListContainer': {
                        top: '10px !important',
                        right: '15px !important',
                    },
                },
            },
            '& .productImage': {
                position: 'relative',
            },
            '& .product-label': {
                position: 'absolute',
                bottom: '10px',
                left: '1px',
                color: palette?.common?.white,
                textTransform: 'uppercase',
                padding: '8px 10px 5px',
                lineHeight: '.8125rem',
                fontSize: '.8125rem',
                fontWeight: 600,
                wordBreak: 'break-word',
            },
            [theme.breakpoints.down(maxWidth?.xs_screen)]: {
                '& .product-label': {
                    padding: '0 10px',
                    lineHeight: '.875rem',
                    fontSize: '.625rem',
                    bottom: '8px',
                },
            },
            '&.productItemContainerRedesign': {
                wordBreak: 'break-all',
                fontFamily: 'Hind, sans-serif',
                '& .imageContainer': {
                    background: 'linear-gradient(-90deg, #e3e3e3 35%, #fcfcfc 50%, #e3e3e3 65%',
                    backgroundSize: '300% 300%',
                    backgroundColor: '#e3e3e3',
                    width: '100%',
                    minHeight: '150px',
                    position: 'relative',
                },
                '& .productImage': {
                    position: 'relative',
                    '& img': {
                        width: '100%',
                    },
                },
                '& img': {
                    width: '100%',
                },
                '& .title': {
                    wordBreak: 'inherit',
                    width: '60%',
                    [theme.breakpoints.down('994')]: {
                        fontSize: '0.875rem',
                        lineHeight: '0.875rem',
                    },
                    '&.withComparePrice': {
                        width: '45%',
                        wordBreak: 'inherit',
                    },
                    float: 'left',
                    paddingRight: '5px',
                    color: '#212324',
                    fontWeight: '400',
                    letterSpacing: '0',
                    '&.plant-occasion-title': {
                        color: palette.common?.black,
                        fontSize: '16px !important',
                        lineHeight: '24px !important',
                        letterSpacing: '0.8px',
                        opacity: '1',
                        width: 'unset !important',
                    },
                },
                '& .only-title': {
                    textAlign: 'center',
                },
                '& .no-float': {
                    float: 'none',
                },
                '& .price': {
                    fontWeight: '700',
                    textAlign: 'right',
                    width: '40%',
                    [theme.breakpoints.between('768', '1025')]: {
                        fontSize: '0.875rem',
                        letterSpacing: '-0.6px',
                    },
                    '&.withComparePrice': {
                        width: '55%',
                        wordBreak: 'keep-all',
                    },
                    float: 'left',
                    '& .line': {
                        textDecoration: 'line-through',
                        marginBottom: '0',
                        [theme.breakpoints.between('768', '1025')]: {
                            fontSize: '0.875rem',
                        },
                    },
                    '&.plant-occasion-price': {
                        width: '100% !important',
                        textAlign: 'left',
                        '& .line, .plant-occasion-price-color': {
                            color: palette.common?.black,
                        },
                    },
                },
                '& .upSellProductDescription': {
                    textAlign: 'left',
                },
                '& .upSellProductButtonGroup': {
                    float: 'right',
                    marginTop: '-34px',
                    marginRight: '9px',
                },

                '& .upSellTitle': {
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    fontSize: '13px',
                    lineHeight: '25px',
                    letterSpacing: '0.02px',
                    fontFamily: "'Hind, sans-serif'",
                    color: palette.common?.black,
                    opacity: 1,
                },
                '& .upSellPrice': {
                    fontWeight: '700',
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    fontSize: '13px',
                    lineHeight: '25px',
                    letterSpacing: '0.02px',
                    fontFamily: "'Hind', sans-serif'",
                    color: palette.common?.black,
                    opacity: 1,
                },
                [theme.breakpoints.down('768')]: {
                    fontSize: '1.125rem',
                    '&.productItemContainer': {
                        fontSize: '1rem',
                        '& .price .wishListContainer': {
                            top: '10px',
                            right: '10px',
                        },
                        '& .title': {
                            minHeight: '35px',
                            width: '100%',
                            wordBreak: 'break-word',
                            float: 'left',
                            padding: '0',
                            display: 'block',
                            '&.withComparePrice': {
                                width: '100%',
                                wordBreak: 'break-word',
                            },
                        },
                        '& .price': {
                            width: '100%',
                            textAlign: 'left',
                            '&.withComparePrice': {
                                width: '100%',
                                wordBreak: 'unset',
                            },
                            '& span': {
                                paddingLeft: '3px',
                                '&:first-child': {
                                    paddingLeft: '0px',
                                },
                                '&:empty': {
                                    '& ~span': {
                                        paddingLeft: '0px !important',
                                    },
                                },
                            },
                        },
                        '&.slider': {
                            padding: '0',
                        },
                        '&:nth-child(odd)': {
                            paddingRight: '8px',
                        },
                        '&:nth-child(even)': {
                            paddingLeft: '8px',
                            '& .wishListContainer': {
                                right: '21px !important',
                            },
                        },
                    },
                    '& .wishListContainer': {
                        top: '10px !important',
                        right: '10px !important',
                    },
                },
            },
            '&.products-slider': {
                '& .slick-slide': {
                    [theme.breakpoints.down('sm')]: {
                        '&:nth-child(odd)': {
                            paddingRight: '3px !important',
                            paddingLeft: '0px !important',
                        },
                        '&:nth-child(even)': {
                            paddingLeft: '3px !important',
                            paddingRight: '0px !important',
                        },
                    },
                    paddingRight: '10px',
                    paddingLeft: '10px',
                },
                '& .slider': {
                    padding: '0',
                },
            },
            '& .zodiacProductTitle': {
                textAlign: 'center',
                fontWeight: 400,
                color: '#212324',
                letterSpacing: 0,
                display: 'block',
                wordBreak: 'break-word',
            },
        },
    };
});

export default Styles;
